<template>
  <div class="vx-row">
    <div class="vx-col md:w-4/4 w-full mb-base">
      <vx-card>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Merchant Code</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <strong>{{ data_merchant.code }}</strong>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Secret Key</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <strong>{{ data_merchant.secret_key }}</strong>
          </div>
        </div>
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="flex flex-wrap-reverse items-center">
            <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span
                  class="mr-2"
                >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ data.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : data.length }} of {{ data.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <div
              class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addInventoryDevice"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Device</span>
            </div>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-input
              class="mb-4 md:mb-0 mr-4"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search..."
            />
            <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
          </div>
        </div>
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="data"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
        ></ag-grid-vue>
        <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
export default {
  name: "MerchantConfiguration",
  components: {
    AgGridVue,
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: " Name",
          field: "name",
          width: 200,
          filter: true,
          /* checkboxSelection: true,
                         headerCheckboxSelectionFilteredOnly: true,
                         headerCheckboxSelection: true,*/
          pinned: "left"
        },
        {
          headerName: "Device Type",
          field: "device_type_name",
          filter: true,
          width: 200
        },
        {
          headerName: "Code",
          field: "code",
          filter: true,
          width: 200
        },
        {
          headerName: "Serial Number",
          field: "serial_number",
          filter: true,
          width: 200
        },
        {
          headerName: "Config",
          field: "config",
          filter: true,
          width: 200
        }
      ],
      data: [],
      data_merchant: {
        config: null
      }
    }
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null)
      } else this.gridOptions.columnApi.setColumnPinned("email", "left")
    }
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 50
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addInventoryDevice() {
      this.$router.push({
        name: "DeviceEnrollment",
        params: { id_merchant: this.id }
      })
    }
  },
  mounted() {
    Axios.Get(url.svd.merchant.detail + "/" + this.id).then(response => {
      this.data_merchant = response.data.merchant[0];
    });
  },
  props: {
    id: {
      type: Number
    }
  }
}
</script>

<style scoped>
</style>